'use strict';

var GridToolbarSystemStatusFlightSentDirective = function GridToolbarSystemStatusFlightSentDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/grid-toolbar-system-status-flight-sent.html'),
    controller: 'GridToolbarSystemStatusFlightSentController'
  };
};
GridToolbarSystemStatusFlightSentDirective.$inject = [];
module.exports = GridToolbarSystemStatusFlightSentDirective;